import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {LocalStorage} from "quasar";

interface I_RegisterUsingEmail{
    firstName:string,
    lastName:string,
    email:string,
    password:string,
    password_retyped:string
}


interface I_AjaxResponse_RegisterUsingEmail{
    status:number,
    statusText:string,
    data: {
        status: string, message: string,userid:string,token_for_permanent_session:string
    }
}

@Component({components:{}})
export default class UserRegister extends Vue {
    loading:boolean=false;
    isPwdHidden:boolean=true;
    isRetypedPwdHidden:boolean=true;
    IsTermsAndConditions_Accepted:boolean=false;
    register_option='';
    registerUsingEmail:I_RegisterUsingEmail={
        firstName:'',
        lastName:'',
        email:'',
        password:'',
        password_retyped:'',

    }

    $refs:any;
    private userStore=getModule(User);


    async registerByEmail(){
        const vueInst=this;
        let res = await <Promise<I_AjaxResponse_RegisterUsingEmail>> axios.post(`${CONFIG_ENV.URL_REGISTERING.register_by_email}`,vueInst.registerUsingEmail);
        return res;
    }

    onResetFormRegisterUsingEmail(){
        this.registerUsingEmail.firstName='';
        this.registerUsingEmail.lastName='';
        this.registerUsingEmail.email='';
        this.registerUsingEmail.password='';
        this.registerUsingEmail.password_retyped='';
        this.IsTermsAndConditions_Accepted=false;
    }

    onSubmitFormRegisterUsingEmail(){
        const vueInst=this;
        if(!vueInst.IsTermsAndConditions_Accepted){
            vueInst.$q.notify({
                color: 'red-5',
                textColor: 'white',
                position:'top-right',
                icon: 'fas fa-exclamation-triangle',
                message: 'Este necesar sa acceptati conditiile de utilizare a platformei!'
            });
            return false;
        }

        if(vueInst.registerUsingEmail.password!=vueInst.registerUsingEmail.password_retyped){
            vueInst.$q.notify({
                color: 'red-5',
                textColor: 'white',
                position:'top-right',
                icon: 'fas fa-exclamation-triangle',
                message: 'Parola reintrodusa nu este la fel ca cea initiala!'
            });
            return false;
        }
        vueInst.registerByEmail().then(function(presponse:I_AjaxResponse_RegisterUsingEmail){
            if(presponse.data.status=='success'){
                LocalStorage.set('isAuthenticated', 'no');
                LocalStorage.set('emailIsChecked', 'no');
                LocalStorage.set('userEmail', vueInst.registerUsingEmail.email);
                LocalStorage.set('token_for_permanent_session', presponse.data.token_for_permanent_session);
                LocalStorage.set('userid', presponse.data.userid);
                vueInst.$router.push({ name: 'bine_ai_venit' });
            }
            else{
                vueInst.$q.notify({
                    color: 'red-5',
                    textColor: 'white',
                    position:'top-right',
                    icon: 'fas fa-exclamation-triangle',
                    message: presponse.data.message
                });
            }
        });
    }

    constructor(){
        super();
    }

    get titleRegisterType():string{
        let v_return:string='';
        if(this.register_option=='using_mail'){
            v_return=' Cu Adresa de Mail';
        }
        if(this.register_option=='using_facebook'){
            v_return=' Cu Contul de Facebook';
        }
        if(this.register_option=='using_gmail'){
            v_return=' Cu Contul de Gmail';
        }
        return v_return;

    }

    onMetodaInregistrareClick(p_mod_inregistrare:string){
        const vueInst=this;
        vueInst.register_option=p_mod_inregistrare;
    }


}
